export default __webpack_public_path__ + "assets/images/0ce1c8d4605289b3d2cae5e65d9c9c38.png";